import React, { Component } from 'react';
import styled from 'styled-components'
import { Block, Divider, Tabs } from "reakit";
import { Box, Flex, Heading } from 'rebass';
import { Content, DesktopBox, MobileHeader, TabHeader } from "../../components/Base";
import { AddButton } from "../../components/Base/Buttons";
import { PostCard } from "../../components/Cards";
import { sortPosts } from "../../utils";

const PageTitle = styled(Heading)`
	font-size: 24px;
	font-weight: 700;
	color: #263039;
	& > span {
			color: #969a9b;
	}
`;

const NewDivider = styled(Divider)`
	color: #969a9b;
	border-color: #969a9b;
`;

class MyPosts extends Component {

	state = {
		posts: []
	};

	componentDidMount() {
		this.fetchMyPosts()
	}

	fetchMyPosts = async () => {
		const { profile } = this.props;
		try {
			let myPostsRef = await this.props.firebase.posts().where('creator_uid', '==', profile.id).get();
			let result = [];
			myPostsRef.docs.forEach(doc => result.push({ id: doc.id, ...doc.data() }));
			this.setState({ posts: result })
		} catch (e) {
			console.log(e)
		}
	};

	render() {
		const { posts } = this.state;
		const { isFaculty, profile } = this.props;
		let sortedPosts = sortPosts(posts);
		sortedPosts = sortedPosts.reverse()
		return (
			<Box p={[0]} m={0}>
				{isFaculty
					? <Box>
						<MobileHeader>
							<PageTitle pt={2} pb={'10px'}>My Posts</PageTitle>
						</MobileHeader>
						<Content p={[0, 3]} pt={[0, 2]}>
							<Box pt={[0, '12px']} pl={[0, 3]} pb={[0, 3]}>
								<AddButton to='/app/posts/new' />
							</Box>
							<Flex flexWrap='wrap' flexDirection={['column', 'row']} p={[2, 0]} pt={[0]}>
								{sortedPosts.map(post => (
									<Box key={post.id} width={1}>
										<Box mx={'auto'} width={[1, 0.6]} >
											<PostCard post={post} profile={profile} {...this.props} />
										</Box>
										<Box width={1}><NewDivider margin={0} padding={0} zIndex={"-9999"} /></Box>
									</Box>
								))}
							</Flex>
						</Content>
					</Box>
					: <Tabs.Container padding={0}>
						{(tabs) => (
							<Block margin={0} padding={0}>
								<Tabs marginLeft={'-5px'} padding={0}>
									<MobileHeader>
										<Heading pt={3}>My Posts</Heading>
										<Tabs.Tab
											tab="pending"
											{...tabs}
										>
											<TabHeader title={'Pending'} />
										</Tabs.Tab>
										<Tabs.Tab
											tab="history"
											{...tabs}
										>
											<TabHeader title={'History'} />
										</Tabs.Tab>
									</MobileHeader>
									<DesktopBox ml={'47px'}>
										<Tabs.Tab
											tab="pending"
											{...tabs}
										>
											<TabHeader title={'Pending'} />
										</Tabs.Tab>
										<Tabs.Tab
											tab="history"
											{...tabs}
										>
											<TabHeader title={'History'} />
										</Tabs.Tab>
									</DesktopBox>
								</Tabs>

								<Content p={[0, 3]} pt={[0, 2]} mt={'-14px'}>
									<Box pt={[0, 2]} pl={[0, 3]} pb={[0, 3]}>
										<AddButton to='/app/posts/new' />
									</Box>
									<Tabs.Panel tab="pending" {...tabs} style={{ transform: 'unset' }}>
										<Flex flexWrap='wrap' flexDirection={['column', 'row']} p={[2, 0]} pt={[0]}>
											{sortedPosts.filter(post => post.status === 0).map(post => (
												<Box key={post.id} width={1}>
													<Box mx={'auto'} width={[1, 0.6]} >
														<PostCard post={post} profile={profile} {...this.props} />
													</Box>
													<Box width={1}><NewDivider margin={0} padding={0} zIndex={"-9999"} /></Box>
												</Box>
											))}
										</Flex>
									</Tabs.Panel>

									<Tabs.Panel tab="history" {...tabs}>
										<Flex flexWrap='wrap' flexDirection={['column', 'row']} p={[2, 0]} pt={[0]}>
											{sortedPosts.filter(post => post.status !== 0).map(post => (
												<Box key={post.id} width={1}>
													<Box mx={'auto'} width={[1, 0.6]} >
														<PostCard post={post} profile={profile} {...this.props} />
													</Box>
													<Box width={1}><NewDivider margin={0} padding={0} zIndex={"-9999"} /></Box>
												</Box>
											))}
										</Flex>
									</Tabs.Panel>
								</Content>
							</Block>
						)}
					</Tabs.Container>

				}
			</Box>
		);
	}
}


export default MyPosts
